import styled from 'styled-components';
import loginBackground from '../../images/ipc_bg_corporate.svg';

// Move this to utils folder
export const calculateFontSizePerScreenWidth = (min, max) => `clamp(${min}px, calc(${min}px + (${max} - ${min}) * ((100vw - 320px) / (1280 - 320))), ${max}px)`;

export const LoginContainer = styled.div`
 ${({ theme }) => ({
    backgroundColor: theme.colors.white,
  })}
  background-image: url(${loginBackground});
  background-repeat: no-repeat;
  background-position-y: bottom;
  background-size: contain;
  min-height: 590px;
  height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  color: #003140;
  padding-top: 4.125rem;
  padding-left: 6rem;
  gap: 1.875rem;
  font-family: Lato;
  @media only screen and (max-width: 768px) {
    /* Add responsive styles for screens with a maximum width of 600 pixels */
    padding: 1.5rem;
  }
`;
export const Header = styled.h1`
  font-size: ${calculateFontSizePerScreenWidth(18, 28)};
  color: #cc0032;
  font-family: Lato;
  font-weight: 500;
`;

export const Title = styled.p`
  font-size: ${calculateFontSizePerScreenWidth(36, 52)};
  line-height: 1.2;
`;

export const SubTitle = styled.p`
  font-size: ${calculateFontSizePerScreenWidth(15, 22)};
  line-height: 1.2;
  font-weight: lighter;
`;

export const CallToAction = styled.button`
  font-size: ${calculateFontSizePerScreenWidth(13, 18)};
  background: #063142;
  border: none;
  color: white;
  padding: 0.75rem 1.563rem;
  cursor: pointer;
  line-height: 2em;
  box-shadow: 0 0.625rem 3.125rem -0.938rem #000000;
  gap: 10px;
  display: flex;
  align-items: center;
`;

export const LoginButton = styled.button`
  font-size: ${calculateFontSizePerScreenWidth(11, 16)};
  background: transparent;
  border: none;
  color: #003140;
  padding: 0.75rem 1.563rem;
  cursor: pointer;
  line-height: 1.5em;
  display: flex;
  align-items: center;
`;

export const Message = styled.span`
  display: flex;
  align-items: center;
`;

export const TroubleLogging = styled.p`
    lineHeight: 2;
    fontSize: 1.75rem;
`;
